module.exports = __webpack_public_path__ + "static/media/hours-icon.48332267.svg";